import React, { Component } from 'react'
import { Provider } from 'react-redux'
import ThemeProvider from './theme.provider'
import * as PackageJson from '../package.json'
import { Store } from 'redux'

const VERSION = PackageJson.version

interface IProps {
    readonly store: Store
}

class App extends Component<IProps> {
    public render() {
        const { store } = this.props
        const appName: string = `${process.env.REACT_APP_TITLE}`.toUpperCase()
        const commonStyle = 'font-weight: bold;font-style: italic;font-style: italic;'
        const style1 = `${commonStyle};font-size: 40px;color: #50668F;`
        const style3 = `${commonStyle};font-size: 10px;color: #555;`
        const style4 = `${commonStyle};font-size: 8px;color: #555;`
        console.log(`%c${appName}%cby NUTES/UEPB\n%cv${VERSION}`, style1, style3, style4)

        return <Provider store={store}>
            <ThemeProvider/>
        </Provider>
    }
}

export default App
